// extracted by mini-css-extract-plugin
export default {"Param":"ParamQ2nz8Ma4FgXX","Param-input":"Param-input1lad50zOVFPU"};